import { Col, Collapse, Input, Row, Spin } from "antd";
import { useEffect, useState, useCallback } from "react";
import { fetchPitchings } from "shared/service/StrmService";
import { LoadingOutlined, UpOutlined } from "@ant-design/icons";
import { ReactComponent as SearchIcon } from "shared/assets/images/icon-search.svg";
import { ReactComponent as QuickQuincyIcon } from "shared/assets/images/icon-quincy-side-menu.svg";
import { ReactComponent as DesertIcon } from "shared/assets/images/desert-icon.svg";
import Markdown from "markdown-to-jsx";
import moment from "moment";
import { useSelector } from "react-redux";
import { ArtistState } from "explorer/reducers/artistas";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import "./PitchingCenter.scss";
import { Trans, useTranslation } from "react-i18next";
import { LinguagemEnum } from "shared/enums/LinguagemEnum";

const PitchingCenter = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [pitchings, setPitchings] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  const formatDate = (date: string) =>
    moment(date).format(
      i18n.language === LinguagemEnum.Portugues ? "DD/MM/YYYY" : "MM/DD/YYYY",
    );

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { response }: any = await fetchPitchings();
    setPitchings(response.items || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const LabelCollapsePitching = ({ pitching }: any) => {
    return (
      <div className="header-item">
        <div className="coluna-nome">{pitching.name}</div>
        <div className="coluna-data">{formatDate(pitching.createdOn)}</div>
      </div>
    );
  };

  const DetailPitching = ({ pitching }: any) => {
    return (
      <Row className="details">
        <Col xs={24}>
          <p className="label">{t("pages.CentralPitching.dataCriacao")}</p>
          <p className="value">{formatDate(pitching.createdOn)}</p>
        </Col>
        <Col xs={24}>
          <p className="label">{t("pages.CentralPitching.dataLancamento")}</p>
          <p className="value">{formatDate(pitching.releaseOn)}</p>
        </Col>
        <Col xs={24}>
          <p className="label">{t("pages.CentralPitching.pitching")}</p>
          <p className="value">
            {pitching.pitching ? (
              <Markdown>{pitching.pitching}</Markdown>
            ) : (
              <></>
            )}
          </p>
        </Col>
      </Row>
    );
  };

  return (
    <div className={`pitching-center ${isMobile ? "mobile" : ""}`}>
      <div
        className={`content ${isMobile ? "mobile" : ""}`}
        style={{
          background: `linear-gradient(180deg, rgba(13, 13, 13, 0.7) 0%, #0D0D0D 85.64%), url(${userArtist?.profileImage}) no-repeat top center`,
        }}
      >
        <Row>
          <p className="title-page">{t("pages.CentralPitching.title")}</p>
        </Row>
        <Row>
          <p className="page-explain">
            {t("pages.CentralPitching.comoFunciona")}
          </p>
        </Row>
        <Row>
          <p className="explain-text">
            <Trans i18nKey="pages.CentralPitching.explicacao" />
          </p>
        </Row>
        <Row className="quick-quincy">
          <div className="header">
            <QuickQuincyIcon /> Quincy
          </div>
          <div className="body">
            <p>{t("pages.CentralPitching.quincyMessage")}</p>
          </div>
          <div className="footer">
            <button
              className="botao-gerar-quincy botao-vazado"
              onClick={() => history.push("/pitching/new")}
            >
              <QuickQuincyIcon /> {t("pages.CentralPitching.criarPitching")}
            </button>
          </div>
        </Row>
        <Row className="row-search">
          <Input
            placeholder={t("pages.CentralPitching.pesquisar")}
            suffix={<SearchIcon />}
            onChange={(ev) => setSearch(ev.target.value)}
            disabled={loading}
          />
        </Row>
        {loading ? (
          <div className="div-loading">
            <Spin indicator={<LoadingOutlined />} />
          </div>
        ) : pitchings.length === 0 ? (
          <Row>
            <Col xs={24} className="no-pitching">
              <div className="icon">
                <DesertIcon />
              </div>
              <div>
                <p className="title">{t("pages.CentralPitching.atencao")}</p>
                <p className="message">
                  {t("pages.CentralPitching.nenhumPitching")}
                </p>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="space-between" className="row-header-collapse">
              <Col>{t("pages.CentralPitching.lancamento")}</Col>
              <Col>{t("pages.CentralPitching.dataCriacao")}</Col>
            </Row>
            <Row justify="space-between">
              <Col xs={24}>
                <Collapse
                  bordered={false}
                  defaultActiveKey={["1"]}
                  expandIcon={({ isActive }) => isActive && <UpOutlined />}
                  className="collapse-pitching"
                  items={pitchings
                    .filter(
                      (x: any) =>
                        !search ||
                        x.name?.toLowerCase().includes(search?.toLowerCase()),
                    )
                    ?.map((pitching: any) => ({
                      key: pitching.id,
                      name: pitching.name,
                      label: <LabelCollapsePitching pitching={pitching} />,
                      children: <DetailPitching pitching={pitching} />,
                    }))}
                  expandIconPosition="end"
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default PitchingCenter;
